import { globalStore } from '../Redux/initStore';
import { deleteUserStampPicture, uploadUserStampPicture } from '../Redux/UserSettingsSlice';
import { GlobalVariables } from './GlobalVariables';
import { ReduxUpdater } from './ReduxUpdater';

export class UserSettingsUpdater {
    private static _stampPreviewPicture = '';
    private static _addStampDialogAnchor: HTMLButtonElement | null = null;
    private static _addStampPreviewAnchor: HTMLButtonElement | null = null;
    private static _collapsedUserCategories: { [id: string]: boolean } = {};

    static get stampPreviewPicture() {
        return this._stampPreviewPicture;
    }

    static get addStampDialogAnchor() {
        return this._addStampDialogAnchor;
    }

    static get addStampPreviewAnchor() {
        return this._addStampPreviewAnchor;
    }

    static readonly handleDeleteUserStamp = (stampId: string) => {
        globalStore.dispatch(deleteUserStampPicture(stampId));
    };

    /**
     * Upload User's Stamp.
     * @param e React Change Event.
     */
    static readonly handleUploadUserStamp = () => {
        if (GlobalVariables.userStampFile) {
            globalStore.dispatch(uploadUserStampPicture(GlobalVariables.userStampFile));
            this._addStampDialogAnchor = null;
        }
    };

    /**
     * Show/Hide upload stamp dialog.
     * @param e React Change Event.
     */
    static readonly showStampDialog = (anchorEl: HTMLButtonElement | null) => {
        GlobalVariables.disableKeyboardShortcuts = anchorEl !== null;
        GlobalVariables.userStampFile = null;
        this._addStampDialogAnchor = anchorEl;
        ReduxUpdater.userSettingsDialogRefresh();
    };

    /**
     * Show/Hide upload stamp dialog.
     * @param e React Change Event.
     */
    static readonly showStampPreviewDialog = (
        anchorEl: HTMLButtonElement | null,
        pictureUrl: string,
    ) => {
        this._addStampPreviewAnchor = anchorEl;
        this._stampPreviewPicture = pictureUrl;
        ReduxUpdater.userSettingsDialogRefresh();
    };

    static checkUserCategoryCollapse(categoryId: string) {
        if (this._collapsedUserCategories[categoryId] === undefined) {
            this._collapsedUserCategories[categoryId] = false;
        }
        return this._collapsedUserCategories[categoryId];
    }

    static toggleUserCategoryCollapse(categoryId: string) {
        if (this._collapsedUserCategories[categoryId] === undefined) {
            this._collapsedUserCategories[categoryId] = false;
        }
        this._collapsedUserCategories[categoryId] = !this._collapsedUserCategories[categoryId];
        ReduxUpdater.userSettingsDialogRefresh();
    }
}
